import { render } from "./About.vue?vue&type=template&id=8a635d52&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=8a635d52&lang=scss&scoped=true"

import exportComponent from "C:\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a635d52"]])

export default __exports__